<template>
    <!-- 首页 -->
    <div>
        <Homeheader />
        <ArticleCard :title="'学术资讯'" @toMore="$router.push({ path: '/academicInformation' })">
            <template #content>
                <ZxItem
                    class="list-item"
                    v-for="item in information"
                    :key="item.artId"
                    :title="item.title"
                    :img="item.cover"
                    :creatTime="item.pushTime"
                    :number="item.detail.pageViews"
                    :author="item.periodical"
                    @click.native="toDetail(item.artType, item.artId)"
                />
            </template>
        </ArticleCard>
        <ArticleCard :title="'学术论文'" @toMore="$router.push({ path: '/academicPaper' })">
            <template #content>
                <div class="lv-list">
                    <div class="lv-list-img-box">
                        <div
                            class="lv-list-img-item"
                            v-for="item in thesis.slice(0, 2)"
                            :key="item.artId"
                            @click="toDetail(item.artType, item.artId)"
                        >
                            <img
                                :src="
                                    item.cover
                                        ? $global.imgUrl + item.cover
                                        : require('@/assets/img/mobile-img/image_error_ic.webp')
                                "
                                alt=""
                            />
                            <div class="lv-list-img-title">
                                <div v-html="item.title"></div>
                            </div>
                        </div>
                    </div>
                    <LvItem
                        class="list-item"
                        v-for="item in thesis.slice(2, 4)"
                        :key="item.artId"
                        :title="item.title"
                        :periodicalName="item.periodical"
                        :periodicalTime="`${item.journalsYear}年第${item.journalsTerm}期`"
                        @click.native="toDetail(item.artType, item.artId)"
                    />
                </div>
            </template>
        </ArticleCard>
        <ArticleCard :title="'学术专著'" @toMore="$router.push({ path: '/academicMonograph' })">
            <template #content>
                <ul class="zz-list">
                    <li
                        v-for="item in monogreaph"
                        :key="item.artId"
                        @click="toDetail(item.artType, item.artId)"
                    >
                        <img
                            :src="
                                item.cover
                                    ? $global.imgUrl + item.cover
                                    : require('@/assets/img/mobile-img/zz_default.png')
                            "
                            alt=""
                        />
                        <div v-html="item.title"></div>
                    </li>
                </ul>
            </template>
        </ArticleCard>
        <ArticleCard :title="'学术会议'" @toMore="$router.push({ path: '/academicConference' })">
            <template #content>
                <div class="hy-list">
                    <div
                        class="hy-top"
                        v-for="item in meeting.slice(0, 1)"
                        :key="item.artId"
                        @click="
                            toDetail(
                                item.artType,
                                item.artId,
                                item.detail.goodsId,
                                item.detail.open
                            )
                        "
                    >
                        <img :src="$global.imgUrl + item.cover" alt="" />
                        <div class="hy-top-text-box">
                            <div class="hy-top-text" v-html="item.title"></div>
                        </div>
                        <p class="hy-top-tiem">
                            {{ item.detail.beginTime.slice(0, 10) }}
                        </p>
                    </div>
                    <ul class="hy-list-box">
                        <li
                            class="hy-list-item"
                            v-for="item in meeting.slice(1, 6)"
                            :key="item.artId"
                            @click="
                                toDetail(
                                    item.artType,
                                    item.artId,
                                    item.detail.goodsId,
                                    item.detail.open
                                )
                            "
                        >
                            <img :src="$global.imgUrl + item.cover" alt="" />
                            <h5 v-html="item.title"></h5>
                            <p>会议时间：{{ item.detail.beginTime.slice(0, 10) }}</p>
                        </li>
                    </ul>
                </div>
            </template>
        </ArticleCard>
        <ArticleCard
            :title="'教育培训'"
            v-if="curriculum.length > 0"
            @toMore="$router.push({ path: '/educationalTraining' })"
        >
            <template #content>
                <div class="px-list">
                    <PxItem
                        class="px-list-item"
                        v-for="item in curriculum"
                        :key="item.artId"
                        :cover="item.cover"
                        :title="item.title"
                        :price="item.detail.curriculumPrice"
                        :saleType="item.detail.saleType"
                        :author="item.detail.publisher"
                        :number="item.detail.enrollment"
                        :logo="item.detail.logo"
                        @click.native="toDetail(item.artType, item.artId, item.detail.goodsId)"
                    />
                </div>
            </template>
        </ArticleCard>
        <ArticleCard
            title="万商数据"
            v-if="reports.length > 0"
            @toMore="$router.push({ path: '/industryReport' })"
        >
            <template #content>
                <div class="px-list">
                    <BgItem
                        class="px-list-item"
                        v-for="item in reports"
                        :key="item.goodsId"
                        :cover="item.cover"
                        :title="item.goodsName"
                        :price="item.dataJsonObj.price"
                        @click.native="toReportDetail(item.goodsId)"
                        :industryOne="item.dataJsonObj.industryLevelOneName"
                        :industryTwo="item.dataJsonObj.industryLevelTwoName"
                    />
                </div>
            </template>
        </ArticleCard>
    </div>
</template>

<script>
import Homeheader from "@/views/mobileView/home/components/homeHeader.vue";
import ArticleCard from "@/views/mobileView/components/articleCard.vue";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
export default {
    name: "index",
    components: {
        Homeheader,
        ArticleCard,
        ZxItem,
        LvItem,
        PxItem,
        BgItem,
    },
    data() {
        return {
            curriculum: [], // 课程
            information: [], // 资讯
            meeting: [], // 会议
            monogreaph: [], // 专著
            thesis: [], // 论文
            reports: [], // 万商数据
        };
    },
    created() {
        this.getRecommendList();
        // document.body.scrollTop = Number(localStorage.getItem('homePageHeight'))
    },
    methods: {
        async getRecommendList() {
            const { content } = await this.$apis.mainServe.getRecommendList();
            this.curriculum = content.curriculum ? content.curriculum : [];
            this.information = content.information ? content.information : [];
            this.meeting = content.meeting ? content.meeting : [];
            this.monogreaph = content.monogreaph ? content.monogreaph : [];
            this.thesis = content.thesis ? content.thesis : [];
            this.reports = content.report ? content.report : [];
        },
        toDetail(type, id, goodsId, open) {
            console.log(type);
            switch (type) {
                case 0:
                    this.$router.push({
                        path: "thesisDetail",
                        query: { type, id },
                    });
                    break;
                case 2:
                    this.$router.push({
                        path: "concentrationDetails",
                        query: { type, id },
                    });
                    break;
                case 5:
                    this.$router.push({
                        path: "msgDetails",
                        query: { type, id },
                    });
                    break;
                case 8:
                    window.open(
                        this.$global.meetingH5Url +
                        `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
                            open ? "&open=" + open : ""
                        }`,
                        "_self"
                    );
                    break;
                case 9:
                    this.$router.push({
                        path: "courseDetails",
                        query: { type, id, goodsId },
                    });
                    break;
            }
        },
        toReportDetail(id) {
            this.$router.push({
                path: "/detail/report",
                query: { id },
            });
        },
    },
};
</script>

<style scoped lang="scss">
.list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

    &:last-child {
        border: none;
    }
}

.lv-list {
    margin-top: 20px;

    .lv-list-img-box {
        display: flex;
        justify-content: space-between;

        .lv-list-img-item {
            position: relative;
            width: 156px;
            height: 156px;
            border-radius: 6px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }

            .lv-list-img-title {
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 6px 10px;
                width: 100%;
                //   height: 49px;
                background: rgba(0, 0, 0, 0.5);

                // opacity: 0.5;
                div {
                    line-height: 19px;
                    font-size: 13px;
                    color: #ffffff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
}

.zz-list {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 20px;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    li {
        flex-shrink: 0;
        margin-left: 15px;
        width: 90px;

        img {
            width: 90px;
            height: 90px;
            object-fit: contain;
            background-color: #fff;
            border-radius: 4px;
        }

        div {
            font-size: 13px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        &:first-child {
            margin-left: 0;
        }
    }
}

.hy-list {
    margin-top: 20px;

    .hy-top {
        position: relative;
        width: 100%;
        height: 184px;
        border-radius: 6px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
        }

        .hy-top-text-box {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            // height: 92px;
            padding: 45px 10px 5px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);

            .hy-top-text {
                font-size: 15px;
                font-weight: 500;
                line-height: 21px;
                color: #ffffff;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }

        .hy-top-tiem {
            position: absolute;
            top: 0;
            right: 0;
            padding: 4px 7px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 0px 0px 0px 6px;
            font-size: 11px;
            color: #ffffff;
        }
    }

    .hy-list-box {
        display: flex;
        flex-wrap: nowrap;
        margin-top: 15px;
        overflow-x: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .hy-list-item {
            flex-shrink: 0;
            margin-right: 10px;
            padding-bottom: 9px;
            width: 150px;
            // height: 166px;
            background-color: rgba(0, 0, 0, 0.04);
            border-radius: 6px;
            overflow: hidden;

            img {
                width: 100%;
                height: 84px;
            }

            h5 {
                min-height: 38px;
                padding: 0 9px;
                font-size: 13px;
                font-weight: 500;
                color: #333333;
                line-height: 19px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            p {
                padding: 12px 9px 0;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.px-list {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .px-list-item {
        margin-bottom: 12px;
        width: 156px;
        border-radius: 6px;
        border: 1px solid #f1f1f1;
        overflow: hidden;
    }
}
</style>
